import api from "@/config/apiConfig"

class QueuesController {

  async index ( req ) {
    try {
      const response = await api.get("/queue", { params: { ...req }});
      return response.data;
    } catch ( error ) {
      console.error( "Erro no QueuesController.index: ", error );
      throw error;
    }
  }
  async create ( req ) {
    try {
      const response = await api.post( `/queue`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no QueuesController.create: ", error );
      throw error;
    }
  }
  async update ( req ) {
    try {
      const response = await api.patch( `/queue/${ req.id }`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no QueuesController.update: ", error );
      throw error;
    }
  }
  async delete ( req ) {
    try {
      const response = await api.delete( `/queue/${ req }` )
      return response.data
    } catch ( error ) {
      console.error( "Erro no QueuesController.delete: ", error )
      throw error
    }
  }
  async test ( id, req ) {
    try {
      const response = await api.post( `/queue/${ id }/test`, req );
      return response.data;
    } catch ( error ) {
      console.error( "Erro no QueuesController.test: ", error );
      throw error;
    }
  }
}

export default new QueuesController()
